import { useGameState } from './hooks/useGameState';
import { useViewportMetrics } from './hooks/useViewportMetrics';
import GameHeader from './components/GameHeader';
import GuideScreen from './components/GuideScreen';
import PracticeScreen from './components/PracticeScreen';
import CountdownScreen from './components/CountdownScreen';
import GameScreen from './components/GameScreen';
import ResultScreen from './components/ResultScreen';
import ExitConfirmModal from './components/ExitConfirmModal';

export default function DsstPage() {
  const metrics = useViewportMetrics();
  const {
    screen,
    symbolMap,
    symbolSetIndex,
    currentSymbol,
    selectedNumber,
    feedback,
    practiceIndex,
    remainingSeconds,
    score,
    totalQuestions,
    correctCount,
    combo,
    numberOrder,
    showExitModal,
    goToPractice,
    handlePracticeSelect,
    goToGame,
    handleGameSelect,
    openExitModal,
    closeExitModal,
    confirmExit,
    goToNext,
  } = useGameState();

  const showHeader = screen === 'guide';

  return (
    <div
      className="dsst-scope w-full bg-secondary-100 flex justify-center overflow-hidden"
      style={{ height: `${metrics.height}px` }}
    >
      <div className="w-full max-w-[430px] h-full bg-secondary-100 flex flex-col overflow-hidden relative game-no-scroll">
        {showHeader && <GameHeader screen={screen} onClose={openExitModal} />}

        <div className="flex-1 overflow-hidden">
          {screen === 'guide' && <GuideScreen onStart={goToPractice} setIndex={symbolSetIndex} />}
          {screen === 'practice' && (
            <PracticeScreen
              symbolMap={symbolMap}
              currentSymbol={currentSymbol}
              selectedNumber={selectedNumber}
              feedback={feedback}
              practiceIndex={practiceIndex}
              setIndex={symbolSetIndex}
              onSelect={handlePracticeSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'countdown' && <CountdownScreen onComplete={goToGame} />}
          {screen === 'game' && (
            <GameScreen
              symbolMap={symbolMap}
              currentSymbol={currentSymbol}
              selectedNumber={selectedNumber}
              feedback={feedback}
              remainingSeconds={remainingSeconds}
              combo={combo}
              setIndex={symbolSetIndex}
              numberOrder={numberOrder}
              onSelect={handleGameSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              totalQuestions={totalQuestions}
              correctCount={correctCount}
              onRetry={goToPractice}
              onNext={goToNext}
            />
          )}
        </div>

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}